import service from '../index';
import config from '@/assets/config.json';

/**
 * @亲子项目审核管理亲子票务管理
 * 
 * @config.babyHttps.api 
 */

const token = localStorage.getItem('Beitoken')

// 获取预约日历
export function getDateList(params) {
    const url = config.babyHttps.api + '/apitravel/admin/calendar/list';
    return service({
        method: 'get',
        url,
        params,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}

// 获取省
export function getDartList(data) {
    const url = config.BeiHttps.api + 'Region/GetOneLevelList';
    return service({
        method: 'get',
        url,
        data,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}

// 获取市
export function getCityList(params) {
    const url = config.BeiHttps.api + 'Region/GetNextLevelList';
    return service({
        method: 'get',
        url,
        params,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}

// 添加/编辑景区
export function setArea(data) {
    const url = config.babyHttps.api + '/apitravel/admin/spu/create';
    return service({
        method: 'post',
        url,
        data,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}

// 获取景区列表数据
export function getArea(params) {
    const url = config.babyHttps.api + '/apitravel/admin/spu/list';
    return service({
        method: 'get',
        url,
        params,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}

// 获取景区详情数据
export function getAreaDetail(params) {
    const url = config.babyHttps.api + '/apitravel/admin/spu/info';
    return service({
        method: 'get',
        url,
        params,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}

// 操作spu审核状态
export function setState(params) {
    const url = config.babyHttps.api + '/apitravel/admin/spu/options';
    return service({
        method: 'get',
        url,
        params,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}

// 获取景区类型
export function getAreaType(params) {
    const url = config.babyHttps.api + '/apitravel/admin/evaluate/dimension-list';
    return service({
        method: 'get',
        url,
        params,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}

